@use 'sass:map';
@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@import '@helsenorge/designsystem-react/scss/breakpoints';

$colors: 'blueberry', 'cherry', 'neutral', 'kiwi', 'banana', 'plum';

.panel {
  $block: &;

  --icon-size: #{spacers.getSpacer(xl)};
  --title-gap: #{spacers.getSpacer(xs)};

  display: block;
  padding: spacers.getSpacer(m);

  &--with-leading-content {
    padding-left: spacers.getSpacer(2xs);

    @media (min-width: map.get($grid-breakpoints, sm)) {
      padding-left: spacers.getSpacer(s);
    }

    #{$block}__content {
      padding-left: calc(var(--icon-size) + var(--title-gap));
    }
  }

  @media (min-width: map.get($grid-breakpoints, sm)) {
    --icon-size: #{spacers.getSpacer(2xl)};
    --title-gap: #{spacers.getSpacer(s)};
  }

  @media (min-width: map.get($grid-breakpoints, lg)) {
    padding-bottom: spacers.getSpacer(xl);
  }

  @each $color in $colors {
    &--#{$color} {
      border: 1px solid map.get(palette.$palette-map, #{$color}200);
      background-color: map.get(palette.$palette-map, #{$color}50);

      &#{$block}__link:hover,
      &#{$block}__link:focus {
        background-color: map.get(palette.$palette-map, #{$color}100);
      }
    }
  }

  &__link {
    text-decoration: none;
    color: inherit;
  }

  &__arrow {
    display: flex;
    flex: none;
    margin-left: auto;
  }

  &__emphasize {
    text-align: center;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: var(--title-gap);
  }

  &__title-text {
    flex: 1;
    min-width: 0;
  }

  &__leading-content {
    display: flex;
    flex: 0 0 var(--icon-size);
    align-items: center;
    justify-content: center;
  }

  &__content {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: spacers.getSpacer(s);
    padding-right: spacers.getSpacer(xs);

    @media (min-width: map.get($grid-breakpoints, sm)) {
      padding-right: spacers.getSpacer(s);
    }
  }
}
